

$(document).ready(function(){
  "use strict";


  function toolTips(){
    $('[data-toggle="tooltip"]').tooltip(); 
  }


  function menuMobile() {
    $('.menu-left').click(function(){
      $('header, #menu-left, .menu-hamburger i').toggleClass('active')
    });
    $('.menu-search').click(function(){
      $('#mobile-search, .menu-search').toggleClass('active')
    });
    $('.mobile-category h5').click(function(){
      $(this).toggleClass('active')
      $(this).next('ul').toggleClass('active')
    });
  }


  function slideMenuMobile() {
    $('.js-btn-menu-mobile').on('click', function() {
      $('.js-menu-mobile').toggleClass('active');
      $('.js-background-overlay').toggleClass('active');
    });

    $('.js-menu-mobile-close').on('click', function() {
      $('.js-menu-mobile').removeClass('active');
      $('.js-background-overlay').removeClass('active');
    });

    $('.js-background-overlay').on('click', function() {
      $(this).removeClass('active');
      $('.js-menu-mobile').removeClass('active');
    });
  }


  function changePlusMinus(){
    $('.change-btn-angle').on('click', function() {

      $(this).find('.btn-angle').toggleClass('active');

    });

    $('.plus-minus2').on('click', function() {

      $('.change-plus-minus2').toggleClass('fa-minus');

    });

    $('.plus-minus3').on('click', function() {

      $('.change-plus-minus3').toggleClass('fa-minus');

    });

    $('.plus-minus4').on('click', function() {

      $('.change-plus-minus4').toggleClass('fa-minus');

    });

    $('.plus-minus5').on('click', function() {

      $('.change-plus-minus5').toggleClass('fa-minus');

    });


  }


  function closeMenu() {
    $( '.menu-hamburger' ).on( "click", function() {

      $(this).toggleClass('active');
      $('.box').toggleClass('active');
      //        $('.content-login').hide();
      //       $('.content-register').hide();
      $('.bg-overlay-menu-mb').toggleClass('active');

    });
    $( '.bg-overlay-menu-mb' ).on( "click", function() {
      $(this).removeClass('active');
      $('.box').removeClass('active');
      $('.menu-hamburger').removeClass('active');
    });





  }

  function cartInRight() {
    $( '.js-cart-pull-right' ).on( "click", function() {

      $('.js-cart-popup').toggleClass('active');
      $('.js-bg').toggleClass('active');
    });
    $( '.js-bg' ).on( "click", function() {
      $(this).removeClass('active');
      $('.js-cart-popup').removeClass('active');
    });
    $( '.closebtn' ).on( "click", function() {
      $('.js-bg').removeClass('active');
      $('.js-cart-popup').removeClass('active');
    });
  }

  function menuLogin() {
    $( '.title-login' ).on( "click", function() {
      $(this).addClass('active');
      $('.title-menu').addClass('active');
      $('.menu-content').hide();
      $('.content-login').addClass('active');
    });
    $( '.title-menu' ).on( "click", function() {

      $(this).removeClass('active');
      $('.title-login').removeClass('active')
      $('.menu-content').show();
      $('.content-login').removeClass('active');
      $('.content-register').removeClass('active');
    });


    $( '.creat-acc' ).on( "click", function() {

      $('.content-login').removeClass('active');
      $('.content-register').addClass('active');
    });

    $( '.back-login' ).on( "click", function() {

      $('.content-login').addClass('active');
      $('.content-register').removeClass('active');
    });
  }

  function searchPopUp() {
    $( '.js-search' ).on( "click", function() {

      $('.search-mobile').toggleClass('active');
      $('.bg-search-mobile').toggleClass('active');
    });
    $( '.bg-search-mobile' ).on( "click", function() {
      $(this).removeClass('active');
      $('.search-mobile').removeClass('active');
    });
    $( '.close-src-mobile' ).on( "click", function() {
      $('.bg-search-mobile').removeClass('active');
      $('.search-mobile').removeClass('active');
    });
  }



  function headerMobile(){
    $(window).on('scroll',function(){

      $('.js-search-mobile').css({'margin-top':function(){
        return $('.js-header-mobile').height() + 10;
      }})

      $('.js-header-mobile').css({'position':'fixed', 'left':'0','right':'0', 'top': '0','z-index':'999'});

      if ($(window).scrollTop()==0) {  
        $('js-header-mobile').css({'position':'unset','background':'#fff'});
      }
    })

  }


  function headerhideFixed(selector) {

    var location = $(selector).position().top;
    var height= $(selector).outerHeight();
    if ($(window).scrollTop() >= location) {
      $(selector).parent().css({'height':function(){
        return height+'px'
      }})
      $(selector).css({'position':'fixed','top':'0','left':'0','right':'0','z-index':'99','background': '#fff'}).addClass('active');
    } 
    if ($(selector).outerHeight() < height) {
      location = height - $(selector).outerHeight();
    }
    if ($(window).scrollTop() < location) {
      $(selector).css({'position':'unset'}).removeClass('active');

    }
    $(window).on('scroll',function(){
      if ($(window).scrollTop() >= location) {
        $(selector).parent().css({'height':function(){
          return height+'px'
        }})
        $(selector).css({'position':'fixed','top':'0','left':'0','right':'0','z-index':'99','background': '#fff'}).addClass('active');
      } 
      if ($(selector).outerHeight() < height) {
        location = height - $(selector).outerHeight();
      }
      if ($(window).scrollTop() < location) {
        $(selector).css({'position':'unset'}).removeClass('active');

      }
    })
    $(window).resize(function(){
      var location = $(selector).position().top;
      var height= $(selector).outerHeight();
      if ($(window).scrollTop() >= location) {
        $(selector).parent().css({'height':function(){
          return height+'px'
        }})
        $(selector).css({'position':'fixed','top':'0','left':'0','right':'0','z-index':'99','background': '#fff'}).addClass('active');
      } 
      if ($(selector).outerHeight() < height) {
        location = height - $(selector).outerHeight();
      }
      if ($(window).scrollTop() < location) {
        $(selector).css({'position':'unset'}).removeClass('active');

      }
      $(window).on('scroll',function(){
        if ($(window).scrollTop() >= location) {
          $(selector).parent().css({'height':function(){
            return height+'px'
          }})
          $(selector).css({'position':'fixed','top':'0','left':'0','right':'0','z-index':'99','background': '#fff'}).addClass('active');
        } 
        if ($(selector).outerHeight() < height) {
          location = height - $(selector).outerHeight();
        }
        if ($(window).scrollTop() < location) {
          $(selector).css({'position':'unset'}).removeClass('active');

        }
      })
    })

  }

  function loginPopup() {
    var xxx=0;
    $('.js-login-popup').click(function() {
      xxx=1;

    })

    $('.js-bg-login').click(function(){


      if (xxx==0) {
        $('.js-bg-login').removeClass('active');
        $('.js-login-popup').removeClass('active');
      }
      else{xxx=0}
    })




    $( '.login-test' ).on( "click", function() {
      $('.js-login-popup').toggleClass('active');
      $('.js-bg-login').toggleClass('active');
    });
    $( '.closebtn-login' ).on( "click", function() {
      $('.js-bg-login').removeClass('active');
      $('.js-login-popup').removeClass('active');


    });

  }

  // Scroll to TOP
  function totop(){
    var back_to_top = $('#back-to-top');
    if (back_to_top.length) {
      var scrollTrigger = 100, // px
          backToTop = function() {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > scrollTrigger) {
              back_to_top.addClass('show');
            } else {
              back_to_top.removeClass('show');
            }
          };
      $(window).on('scroll', function() {
        backToTop();
      });
      back_to_top.on('click', function(e) {
        e.preventDefault();
        $('html,body').animate({
          scrollTop: 0
        }, 700);
      });
    }
  }



  function loginRegister() {

    $('.js-account-admin').click(function() {
      $('.customer-form').show(); $('.customer-form-register').hide();

    })

    $('.login-test').click(function() {
      $('.customer-form').show(); $('.customer-form-register').hide();

    })

    $('.creat-acc').click(function() {
      $('.customer-form').hide(); $('.customer-form-register').show();

    })
    $('.back-login').click(function() {
      $('.customer-form').show(); $('.customer-form-register').hide();

    })

  }

  function matchHeight(){
    jQuery(function() {
      jQuery('.matchHeight').matchHeight();
    });

  }

  function searchBoxPullRight(){
    $( '.ic-search-btn' ).on( "click", function() {
      $('.search-box-dsk').toggleClass('active');

    });
  }

  function cartCheckOut(){
    $( '.js-cart-checkout' ).on( "click", function() {
      $('.cart-checkout').toggleClass('active');


    });
  }


  function SortTabContent(){
    $( '.product-v1' ).find('ul').children().eq(2).addClass('active')
    $( '.product-v1' ).find('.tab-content').eq(2).removeClass('active1').addClass('x active2')

    $( '.product-v1' ).find('li').each( function() {
      $(this).on("click", function(){
        var link = $ (this).find('a').attr('data-target');
        $('.product-v1').find('.x').addClass('active1').removeClass('x active2');
        $('.product-v1').find('.active').removeClass('active');
        $('#' + link).removeClass('active1').addClass('x active2');
        $(this).addClass('active')  
      })
    });
  }

  function tabProdDetail(){
    $( '.product-tab-info1' ).find('ul').children().eq(0).addClass('active')
    $( '.content-tab-des1').addClass('x active')

    $( '.product-tab-info1' ).find('li').each( function() {
      $(this).on("click", function(){
        var link = $ (this).find('a').attr('data-target');
        $('.product-tab-info1').find('.x').removeClass('x active');
        $('.product-tab-info1').find('.active').removeClass('active');
        $('#' + link).addClass('x active');
        $(this).addClass('active')  
      })
    });
  }

  function tabProdDetailv2(){
    $( '.product-tab-info2' ).find('ul').children().eq(0).addClass('active')
    $( '.content-tab-des2').addClass('y active')

    $( '.product-tab-info2' ).find('li').each( function() {
      $(this).on("click", function(){
        var link = $ (this).find('a').attr('data-target');
        $('.product-tab-info2').find('.y').removeClass('y active');
        $('.product-tab-info2').find('.active').removeClass('active');
        $('#' + link).addClass('y active');
        $(this).addClass('active')  
      })
    });
  }


  function testimonialV1Slide(){
    $('.slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.slider-nav'
    });
    $('.slider-nav').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      dots: false,
      prevArrow:'<button type="button" class="prev-slide"> <img src="//vitalia.center/cdn/shop/t/7/assets/next-copy1.png?v=116313215724410035051793049493""></button>',
      nextArrow:'<button type="button" class="next-slide"> <img src="//vitalia.center/cdn/shop/t/7/assets/next2.png?v=68357943757478457601793049493" "></button>',         
      centerMode: true,
      focusOnSelect: true,

      responsive: [
      {
      breakpoint: 1024,
      settings: {
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      dots: true
    }
                           },
    {
      breakpoint: 600,
      settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
        }
    },

    ]
   });
  }

  function productDetail(){
    $('.product-img-parent').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      infinite: false,
      asNavFor: '.product-img-sub'
    });
    $('.product-img-sub').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      asNavFor: '.product-img-parent',
      dots: false,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',         
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false
          }
        },

      ]
        });
        }



        function testimonialV2(){

        $('.js-testimonial-v2').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-double-left" aria-hidden="true"></i></button>',
        nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-double-right" aria-hidden="true"></i></button>',
        autoplaySpeed: 2000,

        });

        }
        function menuSlideshow(){

        $('.js-menu-slideshow').slick({
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        infinite: true,
        adaptiveHeight: true
        });
        $('.js-menu-slideshow .slide-show img').eq(0).addClass('active')
        $('.js-menu-slideshow .slide-show .content-slide').eq(0).addClass('active')
        $('.js-menu-slideshow').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var mySlideNumber = nextSlide;
        var prev = mySlideNumber - 1;
        $('.js-menu-slideshow .slide-show img').eq(mySlideNumber).addClass('active');
        $('.js-menu-slideshow .slide-show .content-slide').eq(mySlideNumber).addClass('active');
        $('.js-menu-slideshow .slide-show img').eq(prev).removeClass('active');
        $('.js-menu-slideshow .slide-show .content-slide').eq(prev).removeClass('active');
        });




        }

  function testimonialAboutUs(){

    $('.js-testimonial-about-us').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      autoplaySpeed: 2000,

    });

  }    



  function jsProductV6(){
    $('.js-product-v6').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-double-left" aria-hidden="true"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-double-right" aria-hidden="true"></i></button>',
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            arrows: false

          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]   
    });


  }


  function jsProdV5(){
    $('.js-product-v5').slick({
      rows: 2,
      slidesPerRow: 6,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      dots: true,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-double-left" aria-hidden="true"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-double-right" aria-hidden="true"></i></button>',
      autoplaySpeed: 2000,	

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesPerRow: 2,
            slidesToScroll: 1,
            rows:2,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesPerRow: 1,
            slidesToScroll: 1,
            rows:2
          }
        },

      ]


        });


        }

        function jsProdRelated(){

        $('.js-product-related').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-double-left" aria-hidden="true"></i></button>',
        nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-double-right" aria-hidden="true"></i></button>',
        autoplaySpeed: 2000,
        responsive: [
        {
        breakpoint: 1024,
        settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: false

        }
        },
        {
        breakpoint: 600,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1
        }
        },
        {
        breakpoint: 480,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false
        }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]   
    });

  }

  function jsSortProd(){
    $('.js-sort-prod-grid').on('click', function() {

      $('.js-prod-items').removeClass('product-item-list');
      $('.js-prod-items').addClass('product-item-grid ');
      $(this).addClass('active');
      $('.js-sort-prod-list').removeClass('active');

    });

    $('.js-sort-prod-list').on('click', function() {
      $('.js-prod-items').removeClass('product-item-grid');
      $('.js-prod-items').addClass('product-item-list');
      $(this).addClass('active');
      $('.js-sort-prod-grid').removeClass('active');

    });





  }

  function FilterInRight() {
    $( '.button-filter' ).on( "click", function() {
      $(this).toggleClass('d-none')
      $('.change-button-filter').toggleClass('d-block')

      $('.filter-mobile ').toggleClass('active');
      $('.bg-filter-overlay').toggleClass('active');
    });

    $( '.change-button-filter' ).on( "click", function() {
      $(this).addClass('d-none')
      $(this).removeClass('d-block')
      $('.button-filter').removeClass('d-none')
      $('.button-filter').addClass('d-block')

      $('.filter-mobile ').removeClass('active');
      $('.bg-filter-overlay').removeClass('active');
    });


    $( '.bg-filter-overlay').on( "click", function() {
      $(this).removeClass('active');
      $('.filter-mobile ').removeClass('active');
      $('.change-button-filter').removeClass('d-block')

      $('.button-filter').removeClass('d-none')
      $('.button-filter').addClass('d-block')

    });
    $( '.closebtn-filter' ).on( "click", function() {
      $('.change-button-filter').removeClass('d-block')

      $('.button-filter').removeClass('d-none')
      $('.button-filter').addClass('d-block')

      $('.bg-filter-overlay').removeClass('active');
      $('.filter-mobile').removeClass('active');
    });
  }


  function jsSlideshowV1(){

    
    $('.js_slideshow_v1').slick({
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      fade: true,
      infinite: true,
      adaptiveHeight: true
    });
    $('.js_slideshow_v1 .bg-slideshow-v1 img').eq(0).addClass('active')
    $('.js_slideshow_v1 .slideshow-v1-info').eq(0).addClass('active')
    $('.js_slideshow_v1').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      var mySlideNumber = nextSlide;
      var prev = mySlideNumber - 1;
      $('.js_slideshow_v1 .bg-slideshow-v1 img').eq(mySlideNumber).addClass('active');
      $('.js_slideshow_v1 .slideshow-v1-info').eq(mySlideNumber).addClass('active');
      $('.js_slideshow_v1 .bg-slideshow-v1 img').eq(prev).removeClass('active');
      $('.js_slideshow_v1 .slideshow-v1-info').eq(prev).removeClass('active');
    });
  }
  
    function jsSlideshowV4(){

    
    $('.js_slide_v4').slick({
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      fade: true,
      infinite: true,
      adaptiveHeight: true
    });
    $('.js_slide_v4 .slide-item-1 img').eq(0).addClass('active')
    $('.js_slide_v4 .slide-item-1 .slide-info').eq(0).addClass('active')
    $('.js_slide_v4').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      var mySlideNumber = nextSlide;
      var prev = mySlideNumber - 1;
      $('.js_slide_v4 .slide-item-1 img').eq(mySlideNumber).addClass('active');
      $('.js_slide_v4 .slide-item-1 .slide-info').eq(mySlideNumber).addClass('active');
      $('.js_slide_v4 .slide-item-1 img').eq(prev).removeClass('active');
      $('.js_slide_v4 .slide-item-1 .slide-info').eq(prev).removeClass('active');
    });
  }

  function jsSlideshowV2(){

    
    $('.js-slideshow-v2-product').slick({
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      fade: true,
      infinite: true,
      adaptiveHeight: true
    });
    $('.js-slideshow-v2-product .bg-slideshow').eq(0).addClass('active')
    $('.js-slideshow-v2-product .product-info').eq(0).addClass('active')
    $('.js-slideshow-v2-product').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      var mySlideNumber = nextSlide;
      var prev = mySlideNumber - 1;
      $('.js-slideshow-v2-product .bg-slideshow').eq(mySlideNumber).addClass('active');
      $('.js-slideshow-v2-product .product-info').eq(mySlideNumber).addClass('active');
      $('.js-slideshow-v2-product .bg-slideshow').eq(prev).removeClass('active');
      $('.js-slideshow-v2-product .product-info').eq(prev).removeClass('active');
    });
  }
  
  function jsProdV4(){
    $('.js-product-v4').slick({
      slidesToShow: 4,
      slidesToScroll: 2,
      autoplay: false,
      arrows: true,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-double-left" aria-hidden="true"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-double-right" aria-hidden="true"></i></button>',
      autoplaySpeed: 2000,

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },

      ]

        });

        }

        function video(){
        $('[data-fancybox]').fancybox({
        youtube : {
        controls : 0,
        showinfo : 0
        },
        vimeo : {
        color : 'f00'
        }
        });
        }








        menuMobile();
        slideMenuMobile();
        changePlusMinus();
        closeMenu() ;
        cartInRight();
        menuLogin();
        searchPopUp();
        loginRegister();
        loginPopup() ;
        searchBoxPullRight();
        cartCheckOut();
        SortTabContent();
        testimonialV1Slide();
        jsProdV4();
        testimonialV2();
        testimonialAboutUs();
        matchHeight();
        productDetail();
        tabProdDetail();
        jsProdV5();
        jsProdRelated();
        tabProdDetailv2();  
        jsSortProd();  
        toolTips();
        FilterInRight() ;
        menuSlideshow();
        jsSlideshowV1();
        jsProductV6();
        headerMobile();
        video();
        totop();
        jsSlideshowV4();
        jsSlideshowV2()

        if ($('header').hasClass('header-v1')) {
        
        headerhideFixed('.js-fixed');
        
        }
        if ($('header').hasClass('header-v2')) {
        
        headerhideFixed('.js-fixed');
        
        }
        if ($('header').hasClass('header-v3')) {
        
        headerhideFixed('.js-fixed');
        
        }
        
        if ($('header').hasClass('header-v4')) {
        
        headerhideFixed('.js-fixed');
        
        }
         if ($('header').hasClass('.header-mobile')) {
        
        headerhideFixed('.js-fixed');
        }
        
        
      








        })



        $(document).ready(function(){

       

        $('.multiple-items').slick({
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay:true,
        autoplaySpeed: 2000,
        arrows: false,

        responsive: [
        {
        breakpoint: 1024,
        settings: {
        slidesToShow: 5,
        slidesToScroll: 2,
        infinite: true,
        dots: true
        }
        },
        {
        breakpoint: 600,
        settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        }
        },

      ]
    });


    $('.slide-product-v1').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay:false,
      autoplaySpeed: 2000,
      arrows: true,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-double-left" aria-hidden="true"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-double-right" aria-hidden="true"></i></button>',  

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },

      ]    

        });






        $('.product-service1').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay:false,
        dots: false,
        arrows: true,
        prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-double-left" aria-hidden="true"></i></button>',
        nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-double-right" aria-hidden="true"></i></button>',  
        autoplaySpeed: 2000,

        });

        $('.product-service2').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay:false,
        dots: true,
        arrows: false,

        autoplaySpeed: 2000,

        responsive: [
        {
        breakpoint: 1024,
        settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
        }
        },
        {
        breakpoint: 600,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        }
        },

      ]

    });


    $('.js-product-deal').slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay:false,
      dots: true,
      autoplaySpeed: 2000,
      arrows: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },

      ]          

        });          


        $('.js-slick-newletter-v1').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay:false,
        dots: false,
        autoplaySpeed: 2000,
        prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
        nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',          
        arrows: true,

        responsive: [
        {
        breakpoint: 1024,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,

        }
        },
        {
        breakpoint: 600,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        }
        },

      ]   
    }); 


    $('.js-service-box-v1').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      arrows: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            arrows: false

          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ] 

    });  

    $('.js-service-box-v2').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      arrows: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            arrows: false

          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]     

    });      

 

    $('.js-product-v2').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 2,
      autoplay: false,
      autoplaySpeed: 2000,
      prevArrow:'<button type="button" class="prev-slide"> <img src="//vitalia.center/cdn/shop/t/7/assets/next-copy1.png?v=116313215724410035051793049493""></button>',
      nextArrow:'<button type="button" class="next-slide"> <img src="//vitalia.center/cdn/shop/t/7/assets/next2.png?v=68357943757478457601793049493" "></button>',          
      arrows: true,
      dots: false,

      responsive: [
      {
      breakpoint: 1024,
      settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: false

    }
                              },

                              {
                              breakpoint: 1400,
                              settings: {
                              slidesToShow: 3,
                              slidesToScroll: 1,
                              infinite: true,
                              dots: false,
                              arrows: false

                              }
                              },
                              {
                              breakpoint: 600,
                              settings: {
                              slidesToShow: 1,
                              slidesToScroll: 1
                              }
                              },
                              {
                              breakpoint: 480,
                              settings: {
                              slidesToShow: 1,
                              slidesToScroll: 1,
                              arrows: false
                              }
                              }
                              // You can unslick at a given breakpoint now by adding:
                              // settings: "unslick"
                              // instead of a settings object
                              ]

                              });

    $('.js-product-v3').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      prevArrow:'<button type="button" class="prev-slide"> <img src="//vitalia.center/cdn/shop/t/7/assets/next-copy1.png?v=116313215724410035051793049493""></button>',
      nextArrow:'<button type="button" class="next-slide"> <img src="//vitalia.center/cdn/shop/t/7/assets/next2.png?v=68357943757478457601793049493" "></button>',          
      arrows: true,
      dots: false,

      responsive: [
      {
      breakpoint: 1024,
      settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: true

    }
                              },


                              {
                              breakpoint: 600,
                              settings: {
                              slidesToShow: 1,
                              slidesToScroll: 1,
                              arrows: false
                              }
                              },
                              {
                              breakpoint: 480,
                              settings: {
                              slidesToShow: 1,
                              slidesToScroll: 1,
                              arrows: false
                              }
                              }
                              // You can unslick at a given breakpoint now by adding:
                              // settings: "unslick"
                              // instead of a settings object
                              ]				

                              });  

    $('.js-testimonial-v3').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay:false,
      dots: true,
      autoplaySpeed: 2000,
      arrows: false,
    });


  });



